import { render, staticRenderFns } from "./RegisterCompany.vue?vue&type=template&id=2c646f1c&scoped=true&"
import script from "./RegisterCompany.vue?vue&type=script&lang=js&"
export * from "./RegisterCompany.vue?vue&type=script&lang=js&"
import style0 from "./RegisterCompany.vue?vue&type=style&index=0&id=2c646f1c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c646f1c",
  null
  
)

export default component.exports